export default __webpack_public_path__ + "static/media/softbd-logo.58d62f91.png";